export default [
    {
        name: "contract",
        path: "/contract",
        component: () => import("@/views/contract/index.vue"),
        redirect: {
            name: "contract-index",
        },
        meta: {
            title: "pages.contract.title",
            keywords: "pages.contract.keywords",
            description: "pages.contract.description",
        },
        children: [
            {
                path: "index",
                name: "contract-index",
                component: () => import("@/views/contract/overview/index.vue"),
                meta: {
                    title: "pages.contract.overview",
                    layout: "default",
                },
            },
            {
                path: "realtime",
                name: "contract-realtime",
                component: () => import("@/views/contract/realtime/index.vue"),
                meta: {
                    title: "pages.contract.realtime",
                    layout: "auth",
                },
            },
            {
                path: "history",
                name: "contract-history",
                component: () => import("@/views/contract/history/index.vue"),
                meta: {
                    title: "pages.contract.history",
                    keepAlive: true,
                    layout: "auth",
                },
            },
            {
                path: "analyze",
                name: "contract-analyze",
                component: () => import("@/views/contract/analyze/index.vue"),
                meta: {
                    title: "pages.contract.analyze",
                    layout: "auth",
                    keepAlive: true,
                },
            },
            {
                path: "anomaly",
                name: "contract-anomaly",
                component: () => import("@/views/contract/anomaly/index.vue"),
                meta: {
                    title: "pages.contract.anomaly",
                    layout: "auth",
                },
            },
            {
                path: "intelligence",
                name: "contract-intelligence",
                component: () => import("@/views/contract/intelligence/index.vue"),
                meta: {
                    title: "pages.contract.intelligence",
                    layout: "auth",
                },
            },
            {
                path: "strategy",
                name: "contract-strategy",
                component: () => import("@/views/contract/strategy/index.vue"),
                meta: {
                    title: "pages.contract.strategy",
                    layout: "auth",
                },
            },
            {
                path: "calc",
                name: "contract-calc",
                component: () => import("@/views/contract/calc/index.vue"),
                meta: {
                    title: "pages.contract.calc",
                    layout: "default",
                },
            },
        ],
    },
];
